// TODO: Move to typescript after an eventual clean up (decide wether we should keep the original non BL varianta)
import {
  map, prop, propOr, mergeRight, mergeWithKey, pick, keys, isEmpty,
} from 'ramda';
import { createSelector } from 'reselect';

import { selectors as bootstrapSelectors } from '@ezugi/bootstrap';
import { BACK, LAY } from '@ezugi/constants';

import { BACK_LAY_BETS, BL_TOTALS } from '../../../constants/BackAndLay/betTypes';
import { getBLPayoutValue } from '../../epics/BackAndLay/utils';
import { currentBetsSelector, totalsSelector } from '../bets';

const {
  chipsSelector,
  currentLimitsSelector,
  payoutsSelector,
  totalBetSelector,
  userBalanceSelector,
} = bootstrapSelectors;

const { TOTAL_PLAYER_A_BACK, TOTAL_PLAYER_B_BACK, TOTAL_PLAYER_A_LAY, TOTAL_PLAYER_B_LAY } = BL_TOTALS;
const { PLAYER_A_BACK, PLAYER_B_BACK, PLAYER_A_LAY, PLAYER_B_LAY } = BACK_LAY_BETS;

export const backBetValuesSelector = createSelector(
  chipsSelector,
  userBalanceSelector,
  totalBetSelector,
  (chips, balance, totalBet) => chips.map((chip) => ({
    ...chip,
    disabled: balance - totalBet < chip.value,
  }))
);

export const playerALayBetValuesSelector = createSelector(
  chipsSelector,
  payoutsSelector,
  userBalanceSelector,
  totalBetSelector,
  (chips, payouts, balance, totalBet) => {
    if (isEmpty(payouts)) {
      return chips.map((chip) => ({
        ...chip,
        disabled: true, // or handle the case when payouts are empty as needed
      }));
    }
    return chips.map((chip) => ({
      ...chip,
      disabled: balance - totalBet < chip.value * payouts[PLAYER_A_LAY].value,
    }));
  }
);

export const playerBLayBetValuesSelector = createSelector(
  chipsSelector,
  payoutsSelector,
  userBalanceSelector,
  totalBetSelector,
  (chips, payouts, balance, totalBet) => {
    if (isEmpty(payouts)) {
      return chips.map((chip) => ({
        ...chip,
        disabled: true, // or handle the case when payouts are empty as needed
      }));
    }
    return chips.map((chip) => ({
      ...chip,
      disabled: balance - totalBet < chip.value * payouts[PLAYER_B_LAY].value,
    }));
  }
);

/* BETS SELECTORS */
export const playerABackSelector = createSelector(
  currentBetsSelector,
  prop(PLAYER_A_BACK)
);

export const playerBBackSelector = createSelector(
  currentBetsSelector,
  prop(PLAYER_B_BACK)
);

export const playerALaySelector = createSelector(
  currentBetsSelector,
  prop(PLAYER_A_LAY)
);

export const playerBLaySelector = createSelector(
  currentBetsSelector,
  prop(PLAYER_B_LAY)
);

/* TOTALS SELECTORS */
export const totalPlayerABackSelector = createSelector(
  totalsSelector,
  propOr(0, TOTAL_PLAYER_A_BACK)
);

export const totalPlayerBBackSelector = createSelector(
  totalsSelector,
  propOr(0, TOTAL_PLAYER_B_BACK)
);

export const totalPlayerALaySelector = createSelector(
  totalsSelector,
  propOr(0, TOTAL_PLAYER_A_LAY)
);

export const totalPlayerBLaySelector = createSelector(
  totalsSelector,
  propOr(0, TOTAL_PLAYER_B_LAY)
);

/* MY BETS SELECTORS */
export const computeMyBetsSelector = createSelector(
  currentBetsSelector,
  payoutsSelector,
  (currentBets, currentPayouts) => {
    const filteredPayouts = map(
      (payoutDetails) => ({
        ...payoutDetails,
        payoutValue: payoutDetails.value,
      }),
      pick(keys(currentBets), currentPayouts),
    );
    const concatValues = (k, l, r) => mergeRight(l, r);
    return mergeWithKey(concatValues, filteredPayouts, currentBets);
  }
);

/* PAYOUTS SELECTORS */
export const payoutsValuesSelector = createSelector(
  payoutsSelector,
  (payouts) => {
    if (isEmpty(payouts)) {
      return {
        [PLAYER_A_BACK]: null,
        [PLAYER_B_BACK]: null,
        [PLAYER_A_LAY]: null,
        [PLAYER_B_LAY]: null,
      };
    }
    return {
      [PLAYER_A_BACK]: getBLPayoutValue(payouts[PLAYER_A_BACK]),
      [PLAYER_B_BACK]: getBLPayoutValue(payouts[PLAYER_B_BACK]),
      [PLAYER_A_LAY]: getBLPayoutValue(payouts[PLAYER_A_LAY]),
      [PLAYER_B_LAY]: getBLPayoutValue(payouts[PLAYER_B_LAY]),
    };
  }
);

/* KEYPAD SELECTORS */
const keypadSelector = prop('keypad');

export const prevStakesSelector = createSelector(
  keypadSelector,
  propOr({}, 'prevStakes')
);

export const prevStakesOrDefaultsSelector = createSelector(
  prevStakesSelector,
  currentLimitsSelector,
  (prevStakes, limits) => ({
    [BACK]: limits.Min_Bet,
    [LAY]: limits.Min_Group1,
    ...prevStakes,
  })
);
